import * as moment from "moment";
import * as React from "react";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
const numeral = require("numeral");

export const columns = [
    {
        dataField: 'id',
        text: '#',
        isKey: true,
        hidden: true,
    },
    {
        dataField: 'any_item',
        text: '#',
        hidden: true,
    },
    {
        dataField: 'serie_nota',
        text: 'Série / Nota'
    },
    {
        dataField: 'data',
        text: 'Data de Emissão',
        classes: columnClassNameFormat,
        formatter: buttonFormatterData,
    },
    {
        dataField: 'data_calculo',
        text: 'Data do Cálculo',
        classes: columnClassNameFormatAtrasadas,
        formatter: buttonFormatterDataCalculo,
    },
    {
        dataField: 'cst',
        text: 'CST / CSON',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'pis_cofins',
        text: 'PIS / COFINS',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'cfop',
        text: 'CFOP',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'ncm',
        text: 'NCM / CEST'
    },
    {
        dataField: 'descricao',
        text: 'Descrição',
        headerStyle: { width: '8%' }
    },
    {
        dataField: 'valor_produto',
        text: 'Produto'
    },
    {
        dataField: 'classificacao_nome',
        text: 'ICMS class.'
    },
    {
        dataField: 'valor_icms_ant',
        text: 'ICMS calc.'
    },
    {
        dataField: 'aliq_icms',
        text: 'ICMS aliq.'
    },
    {
        dataField: 'valor_pagar',
        text: 'A pagar'
    }
];

export const columns_notas_retroativas = [
    {
        dataField: 'id',
        text: '#',
        isKey: true,
        hidden: true,
    },
    {
        dataField: 'any_item',
        text: '#',
        hidden: true,
    },
    {
        dataField: 'serie_nota',
        text: 'Série / Nota'
    },
    {
        dataField: 'data',
        text: 'Data de Emissão',
        classes: columnClassNameFormat,
        formatter: buttonFormatterData,
    },
    {
        dataField: 'dhrecbto',
        text: 'Data Autorização',
        classes: columnClassNameFormat,
        formatter: buttonFormatterData,
    },
    {
        dataField: 'data_calculo',
        text: 'Data do Cálculo',
        classes: columnClassNameFormatAtrasadas,
        formatter: buttonFormatterDataCalculo,
    },
    {
        dataField: 'pis_cofins',
        text: 'PIS / Coffins'
    },
    {
        dataField: 'ncm',
        text: 'NCM / CEST'
    },
    {
        dataField: 'descricao',
        text: 'Descrição'
    },
    {
        dataField: 'valor_produto',
        text: 'Valor do produto'
    },
    {
        dataField: 'classificacao_nome',
        text: 'ICMS class.'
    },
    {
        dataField: 'valor_icms_ant',
        text: 'ICMS calc.'
    },
    {
        dataField: 'aliq_icms',
        text: 'ICMS aliq.'
    },
    {
        dataField: 'valor_contestado_icms',
        text: 'Contestado'
    },
    {
        dataField: 'valor_pagar',
        text: 'A pagar'
    },
];

export const columns_nfse = [
    {
        dataField: 'id',
        text: '#',
        isKey: true,
        hidden: true,
    },
    {
        dataField: 'nnfe',
        text: 'Nota',
        headerStyle: { width: '3%' }
    },
    {
        dataField: 'data',
        text: 'Data',
        formatter: buttonFormatterDataNew,
        headerStyle: { width: '6%' }
    },
    {
      dataField: 'competencia',
      text: 'Competência',
      formatter: formaterDate,
      headerStyle: { width: '6%' }
    },
    {
        dataField: 'data_calculo',
        text: 'Data Cálculo',
        formatter: buttonFormatterDataNew,
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor',
        text: 'Valor',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_deducoes',
        text: 'Valor Deduções',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_pis',
        text: 'Valor Pis',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_cofins',
        text: 'Valor Cofins',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_iss',
        text: 'Valor Iss',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_ir',
        text: 'Valor Ir',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_csll',
        text: 'Valor Csll',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'valor_inss',
        text: 'Valor Inss',
        headerStyle: { width: '6%' }
    },
    {
        dataField: 'descricao',
        text: 'Descrição',
        headerStyle: { width: '22%' }
    }
];


export const columns_cte = [
    {
        dataField: 'id',
        text: '#',
        isKey: true,
        hidden: true,
    },
    {
        dataField: 'any_item',
        text: '#',
        hidden: true,
    },
    {
        dataField: 'serie_nota',
        text: 'Série / Nota',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'chave',
        text: 'Chave',
        headerStyle: { width: '20%' }
    },
    {
        dataField: 'data',
        text: 'Data de Emissão',
        formatter: buttonFormatterData,
    },
    {
        dataField: 'cnpj_emitente',
        text: 'CNPJ Emitente'
    },
    {
        dataField: 'cfop',
        text: 'CFOP',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'cest',
        text: 'CEST',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'calculo',
        text: 'Cálculo',
        headerStyle: { width: '20%' }
    },
    {
        dataField: 'valor',
        text: 'Valor',
        formatter: buttonFormatterValor
    },
    {
        dataField: 'valor_pagar',
        text: 'A pagar',
        formatter: buttonFormatterValor
    },
]

export const columns_nao_calculados = [
    {
        dataField: 'id',
        text: '#',
        isKey: true,
        hidden: true,
    },
    {
        dataField: 'any_item',
        text: '#',
        hidden: true,
    },
    {
        dataField: 'serie_nota',
        text: 'Série / Nota',
        headerStyle: { width: '7%' }
    },
    {
        dataField: 'data',
        text: 'Data de Emissão',
        formatter: buttonFormatterData,
        headerStyle: { width: '10%' }
    },
    {
        dataField: 'ncm',
        text: 'NCM / CEST',
        headerStyle: { width: '10%' }
    },
    {
        dataField: 'descricao',
        text: 'Descrição',
        headerStyle: { width: '15%' }
    },
    {
        dataField: 'cnpj_destino',
        text: 'CNPJ',
        headerStyle: { width: '10%' }
    },
    {
        dataField: 'razao_social',
        text: 'Razão Social',
        headerStyle: { width: '10%' }
    },
    {
        dataField: 'valor_produto',
        text: 'Valor do produto',
        headerStyle: { width: '10%' }
    },
    {
        dataField: 'classificacao_nome',
        text: 'ICMS class.',
        headerStyle: { width: '5%' }
    },
    {
      dataField: 'aliquota_icms_origem',
      text: 'Alq. Origem',
      headerStyle: { width: '5%' },
      formatter: (cell, row) => { return (!cell ? "" : `${cell}%`)}
    },
    {
        dataField: 'chave',
        text: 'Chave',
        headerStyle: { width: '20%' }
    }
];

export function formaterDate(cell, row) {

  if(cell){
    return (<>{moment(cell).format("DD/MM/YYYY")}</>)
  }

  return "N/A"
};

export function columnClassNameFormatAtrasadas(fieldValue, row, rowIdx, colIdx,) {
    if (ResultadoStore.obs.notasDivergentes || ResultadoStore.obs.notasManual) {
        return "td-column-retroativas";
    } else {
        return "";
    }
};

export function buttonFormatterData(cell, row) {
    return (
        <>
            {moment(cell).format("DD/MM/YYYY")}  <br /> {moment(row.data_calculo).add(3, "hours").format("HH:mm")}
        </>
    );
};

export function buttonFormatterDataNew(cell, row) {
    return (
        <>
            {moment(cell).format("DD/MM/YYYY")} {moment(cell).format("HH:mm")}
        </>
    );
};

export function buttonFormatterDataCalculo(cell, row) {
    return (
        <>
            {row.valor_contestacao_icms || row.contestacao_calc_id
                ? (
                    <>
                        {moment(row.data_calculo).format("DD/MM/YYYY")} <br />
                        {moment(row.data_calculo).add(3, "hours").format("HH:mm")}
                    </>
                )
                : (
                    <>
                        {moment(row.data_calculo).format("DD/MM/YYYY")} <br />
                        {moment(row.data_calculo).add(3, "hours").format("HH:mm")}
                    </>
                )}
        </>
    );
};

export function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
    if (
        ResultadoStore.obs.notasRetroativas || ResultadoStore.obs.notasDivergentes ||
        ResultadoStore.obs.notasManual
    ) {
        return "td-column-retroativas";
    } else {
        return "";
    }
};

export function buttonFormatterValor(cell, row) {
    return (
        <>
            R$ {numeral(cell).format("0,0.00")}
        </>
    );
};

export const columns_filter = [
    {
        dataField: 'id',
        text: '#',
        isKey: true,
        hidden: true,
    },
    {
        dataField: 'serie_nota',
        text: 'Série / Nota'
    },
    {
        dataField: 'data',
        text: 'Data de Emissão',
    },
    {
        dataField: 'data_calculo',
        text: 'Data do Cálculo',
    },
    {
        dataField: 'pis_cofins',
        text: 'PIS / Coffins',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'cfop',
        text: 'CFOP',
        headerStyle: { width: '5%' }
    },
    {
        dataField: 'ncm',
        text: 'NCM / CEST',
        headerStyle: { width: '8%' }
    },
    {
        dataField: 'descricao',
        text: 'Descrição',
    },
    {
        dataField: 'valor_produto',
        text: 'Produto'
    },
    {
        dataField: 'classificacao_nome',
        text: 'ICMS class.'
    },
    {
        dataField: 'valor_icms_ant',
        text: 'ICMS calc.'
    },
    {
        dataField: 'aliq_icms',
        text: 'ICMS aliq.'
    },
    {
        dataField: 'valor_contestado_icms',
        text: 'Contestado'
    },
    {
        dataField: 'valor_pagar',
        text: 'A pagar'
    },
    {
        dataField: 'acoes',
        text: ''
    }
];
